<template>
  <div style="    background: #fff;">
    <div style="padding:20px 0 20px 150px">商品价格配置</div>
    <div style="">
      <a-form :form="modelForm">
        <a-form-item
          label="分类名称"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-select
            v-model="categoryId"
            placeholder="请选择适用范围"
            allow-clear
            show-search
            option-filter-prop="children"
            @change="asd"
            style="    width: 300px;"
          >
            <a-select-option v-for="item in applicableEnds" :key="item.id">
              {{ item.categoryName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- e.preventDefault()
      this.form.validateFields((err, values) => { -->
        <a-form-item
          label="商品规格"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
        >
          <div
            v-for="(data, indexs) in list"
            :key="indexs"
            style=" background: #f0f2f5;margin-bottom: 15px;    position: relative;   padding: 20px 0;"
          >
            <div style=" display: flex;">
              <div style="width:80px;text-align: center;">规格项:</div>
              <!-- v-decorator="[
                  'advertName',
                  { rules: [{ required: true, message: '请输入商品分类名称' }] }
                ]" -->
              <a-input
                v-model="list[indexs].specsName"
                placeholder="请输入商品分类名称"
                allow-clear
                style="height: 100%;width: 300px;"
              />
            </div>
            <div style=" display: flex; align-items: center;  ">
              <div
                style=" "
                v-for="(items, index) in data.specsValue"
                :key="index"
              >
                <a-tag closable @close="submit(items, 1, index, indexs)">{{
                  items.name
                }}</a-tag>
              </div>
              <a-button type="link" @click="standard(indexs)">
                添加规格值
              </a-button>
            </div>

            <div
              @click="remove(data, indexs)"
              style="    width: 30px; position: absolute;right: 37px;top: 37px;"
            >
              <img
                src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20230411/168120247420795a8f6ac608242ef97bedf25572df973.png"
              />
            </div>
          </div>
        </a-form-item>

        <a-form-item
          label=" "
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-button @click="backPage">
            添加规格项目
          </a-button>
          <a-button icon="download" style=" margin:0 20px;"  @click="batchDownload">
            下载模板
          </a-button>
          <a-upload
            name="file"
            :file-list="fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <a-button icon="upload" type="primary">
              上传文件
            </a-button>

          </a-upload>

          <!-- <a-button type="primary" html-type="submit">
            批量导入
          </a-button> -->
        </a-form-item>
        <a-form-item
          label="规格列表"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-table
            class="table-content"
            :columns="columns"
            bordered
            :data-source="tableData"
            :row-key="record => record.id"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
          >
            <template slot="marketPrice" slot-scope="text, record">
              <a-input
                v-model="record.marketPrice"
                placeholder=""
                allow-clear
                @change="e => handle(e.target.value, record, text)"
              />
            </template>

            <template slot="evaluatePrice" slot-scope="text, record">
              <a-input

                v-model="record.evaluatePrice"
                placeholder=""
                allow-clear
                @change="e => handleChange(e.target.value, record, text)"
              />
            </template>
            <template slot="state" slot-scope="text, record">

              <a-switch
                v-if="record.state == 0"
                :default-checked="true"
                @change="e => setAudioStatus(e, record)"
              />
              <a-switch
                v-else
                :default-checked="false"
                @change="e => setAudioStatus(e, record)"
              />
            </template>
            <template slot="operation" slot-scope="text, record">
              <!-- <a-popconfirm title="是否要删除此行？" @confirm="removeMember(record)"> -->
                <a @click="removeMember(record)">删除</a>
              <!-- </a-popconfirm> -->
            </template>

          </a-table>
        </a-form-item>
      </a-form>
    </div>
    <a-modal v-model="picVisible" :footer="null">
      <a-input
        v-model="desc"
        placeholder="请填写规格值"
        type="textarea"
        rows="5"
        :max-length="30"
        allow-clear
        style="margin-top: 30px;"
        @change="inp"
      />
      <div style="display: flex;justify-content: center;margin-top:10px">
        <a-button @click="handleOk" style=" margin-right: 20px;">
          取消
        </a-button>
        <a-button type="primary" @click="submit(desc, 0, '', indexs)">
          提交
        </a-button>
      </div>
    </a-modal>
    <div style=" padding-bottom: 20px; text-align: center;">
      <a-button type="" @click="goback">返回</a-button
      ><a-button type="" @click="reset" style="    margin: 0 20px;">重置</a-button
      ><a-button type="primary" @click="save">保存</a-button>
    </div>
  </div>
</template>

<script>
// import { detail, getList, save } from '../../api/build';
import { getList, save, evaluate, fications } from "@/api/appRegulated";
export default {
  data() {
    return {
      specsMap: {},
      NewspecsMap:[],
      modelForm: this.$form.createForm(this, { name: "appRegulateDelt" }),
      applicableEnds: [],
      list: [{ name: "规格项", specsName: "", specsValue: [] }],
      tag: [],
      picVisible: false,
      desc: "", //规格值
      indexs: 0,
      loading: false,

    columns: [
        // {
        //   title: "规格图片",
        //   dataIndex: "createTime"
        // },
        {
          title: "市场价(元)",
          dataIndex: "marketPrice",
          scopedSlots: { customRender: "marketPrice" },
          // width: 100
        },
        {
          title: "回收价(元)",
          dataIndex: "evaluatePrice",
          scopedSlots: { customRender: "evaluatePrice" },
          // width: 100
        },
        {
          title: "启用状态",
          // width: 100,
          scopedSlots: { customRender: "state" }
        },{
          title:'操作',
          scopedSlots: { customRender: "operation" }

        }
      ],

      pagination: {
        pageNo: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => "共" + total + "条记录",
        pageSizeOptions: ["100", "200", "300", "400"],
        defaultPageSize: 100,
        pageSize: 100,
        total: 0
      },

      tableData: [],
      descList: [],
      categoryId: "", //分类id
      fileList: [],
      neWcolumns:[],
      newData:[]
    };
  },
  mounted() {
    this.getTableData();

    if (this.$route.query.id) {
      this.evaluate();
      this.categoryId = this.$route.query.id;
    }
  },
  methods: {
    // 编辑
    evaluate() {
      const that = this;
      const param = {};
      param.queryParams = {
        categoryId: that.$route.query.id
      };

      param.page = that.pagination.pageNo;
      param.pageSize = that.pagination.pageSize;
      evaluate(param).then(res => {
        const data = res.result;
        that.tableData = JSON.parse(
          JSON.stringify(res.result.specificationsLists)
        );
               this.newData = this.tableData
        // console.log(this.newData.length,'sdf')
       let b = res.result.specificationsLists;
        let length
        b.forEach((val, index) => {
          delete val.categoryId;
          delete val.evaluatePrice;
          delete val.id;
          delete val.marketPrice;
          delete val.sort;
          delete val.specsTemplate;
          delete val.state;
          delete val.evaluateType
          length = Math.max(Object.keys(val).length)
          // if(Math.max(Object.keys(val).length)){
          //   console.log(index,val.length,Object.keys(val).length,'index')
          // }

        });
        let indexs = ''
        b.forEach((val,index)=> {
         if(length == Math.max(Object.keys(val).length)) {
            indexs = index
         }
        })

        Object.keys(b[indexs]).forEach((a, index) => {

          that.columns.unshift({
            title: a,
            dataIndex: a,
            // width: 150
          });
        });

 this.neWcolumns = this.columns
        const specsValue = [];
        const godList = JSON.parse(
          JSON.stringify(res.result.evaluateSpecifications)
        );
        let godLists = JSON.parse(
          JSON.stringify(res.result.evaluateSpecifications)
        );

        let titleList = godLists.map(item => {
          return item.specsName;
        });
        let myObj = that.getRepeatNum(titleList),
          winningList = [];
        for (let i in myObj) {

          let obj = {
            specsName: i,
            num: myObj[i],
            specsValue: []
          };
          winningList.push(obj);
        }
        godLists.forEach((val, index) => {
          winningList.map((vals, indexs) => {
            if (val.specsName == vals.specsName) {
              vals.specsValue.push({ name: val.specsValue, id: val.id });
            }
          });
        });
        that.list = winningList;

        // godList.forEach((val,index)=> {
        //   console.log(val,'val')
        //   if(godLists[index].specsName == val.specsName){
        //      specsValue.push({name:val.specsValue,id:val.id})
        //     // that.list[index] = {}
        //     that.list[index].specsName = val.specsName

        //     that.list[index].specsValue = specsValue
        //   }

        // })
      });
    },
    getRepeatNum(titleList) {
      return titleList.reduce((prev, next) => {
        prev[next] = prev[next] + 1 || 1;
        return prev;
      }, {});
    },


      batchDownload () {
      window.open('https://ito-cloud-img.oss-cn-beijing.aliyuncs.com/%E6%A8%A1%E6%9D%BF.xls')
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isExcel =
        file.name.split(".")[file.name.split(".").length - 1] === "xlsx" ||
        file.name.split(".")[file.name.split(".").length - 1] === "xls";
      if (isText || isTextComputer || isExcel) {
        if (!isLt10M) {
          this.$message.error("上传文件大小不能超过 10MB!");
          return false;
        }
      } else {
        this.$message.error("请选择Excel文件上传!");
        return false;
      }
    if( !this.categoryId){
        this.$message.error("请选择分类名称");
        return false;
      }
      this.fileList = [file];

      this.batchConfirm();
      // return false
    },
    // 上传表格
    batchConfirm() {

      const { fileList } = this;
      if (fileList.length <= 0) {
        this.$message.error("请选择文件再上传!");
        return false;
      }
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append("file", file);
        formData.append("categoryId", this.categoryId);
      });
      // this.uploading = true
      var config = {
        headers: { "Content-Type": "multipart/form-data;charset=UTF-8" }
      };

      this.$httpPost(this.$basePath.fications, formData, config)
        .then(res => {
        const data = res.result;

        this.tableData = JSON.parse(
          JSON.stringify(res.result.specificationsLists)
        );
        this.newData = this.tableData

        let b = res.result.specificationsLists;
        let length
        b.forEach((val, index) => {
          delete val.categoryId;
          delete val.evaluatePrice;
          delete val.id;
          delete val.marketPrice;
          delete val.sort;
          delete val.specsTemplate;
          delete val.state;
          delete val.evaluateType

         length = Math.max(Object.keys(val).length)

        });

        let num = ''
        b.forEach((val,index)=> {

         if(length == Math.max(Object.keys(val).length)) {
            num = index
         }
        })

        Object.keys(b[num]).forEach((a, index) => {

          this.columns.unshift({
            title: a,
            dataIndex: a,
            // width: 150
          });
        });

          this.neWcolumns = this.columns
        const specsValue = [];
        const godList = JSON.parse(
          JSON.stringify(res.result.evaluateSpecifications)
        );
        let godLists = JSON.parse(
          JSON.stringify(res.result.evaluateSpecifications)
        );

        let titleList = godLists.map(item => {
          return item.specsName;
        });
        let myObj = this.getRepeatNum(titleList),
          winningList = [];
        for (let i in myObj) {

          let obj = {
            specsName: i,
            num: myObj[i],
            specsValue: []
          };
          winningList.push(obj);
        }
        godLists.forEach((val, index) => {
          winningList.map((vals, indexs) => {
            if (val.specsName == vals.specsName) {
              vals.specsValue.push({ name: val.specsValue, id: val.id });
            }
          });
        });
        this.list = winningList;

        })
        .catch(() => {
          this.uploading = false;
        });
    },
    asd(val) {

      this.categoryId = val;
    },
    backPage() {
      this.list.push({ name: "规格项", id: [], specsName: "", specsValue: [] });
    },
    standard(e) {
      this.desc = "";
      this.indexs = e;
      this.picVisible = true;
    },
    handleOk() {
      this.picVisible = false;
    },
    inp() {},
    getDescList(specsMap) {

      let nameArray = new Array();
      let array = [];
      for (const key in specsMap) {
        nameArray.push(key);
        array.push(specsMap[key]);
      }

      let count = 1;
      array.forEach(item => (count *= item.length));

      let lstResult = [];
      for (let i = 0; i < count; ++i) {
        let lstTemp = {};
        let j = 1;
        for (let k = 0; k < array.length; k++) {
          let item = array[k];
          j *= item.length;
          let index = parseInt(i / parseInt(count / j)) % item.length;

          lstTemp[nameArray[k]] = item[index];
        }
        lstResult.push(lstTemp);
      }
      return lstResult;
    },


    uuid2() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 32; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23];
      var uuid = s.join("");
      return uuid;
    },

    submit(value, type, idx, indexs,text) {
      if(this.$route.query.id || this.fileList.length > 0 ) {
        this.specsMap = {}

        this.picVisible = false;
       if (type == 0) {
        let id = this.uuid2();

        this.list[indexs].specsValue.push({ name: value, id: id });
      }
      //  specs =[]
    // this.list.forEach((val,index)=> {
    //   specs = this.specsMap[val.specsName];
    //     // if (!(specs != undefined && specs.length > 0)) {
    //       specs = new Array();
    //     // }
    //     console.log(specs,'specs')
    //     val.specsValue.map((e,i)=> {
    //       specs.push(e.name);
    //     })
    // })

    this.list.forEach((val,index)=> {

       specs = this.specsMap[val.specsName];
        specs = new Array();
     val.specsValue.map((e,i)=> {
          specs.push(e.name);
        })


      if (type == 0) {
        // if (!(specs != undefined && specs.length > 0)) {
        //   specs = new Array();
        // }
        // val.specsValue.map((e,i)=> {
        //   specs.push(e.name);
        // })


      } else if (type == 1) {
        specs = specs.filter((num, index) => {
          return num !== value;
        });
        // console.log(specs,'this.list[indexs]this.list[indexs]')
        // this.list[indexs].specsValue.splice(idx, 1); //删除 tag
        specs.splice(idx, 1); //删除 tag
      }

      // console.log(this.specsMap,'this.specsMapthis.specsMapthis.specsMapthis.specsMapthis.specsMap')
      if (type == 2) {
        this.specsMap[val.specsName] = specs;

        if(index == indexs){
          delete this.specsMap[val.specsName];
        }

      } else {

        this.specsMap[val.specsName] = specs;
      }
        })

      this.columns = [];


      for (const key in this.specsMap) {

        this.columns.push({
          title: key,
          dataIndex: key,

        });

      }


      this.columns.push(
        // {
        //   title: "规格图片",
        //   dataIndex: "createTime",
        // },
        {
          title: "市场价(元)",
          dataIndex: "marketPrice",
          scopedSlots: { customRender: "marketPrice" },
          // width: 100
        },
        {
          title: "回收价(元)",
          dataIndex: "evaluatePrice",
          scopedSlots: { customRender: "evaluatePrice" },
          // width: 100
        },
        {
          title: "启用状态",
          // width: 100,
          scopedSlots: { customRender: "state" }
        },{
          title:'操作',
          scopedSlots: { customRender: "operation" }

        }
      ),


      //  this.columns = this.neWcolumns.filter((num, index) => {
      //   console.log(num,value,'循环num')
      //     return num !== value;
      //   });

      // this.columns = this.neWcolumnss

          // this.tableData = this.getDescList(this.specsMap);

          // this.descList = this.getDescList(this.specsMap) ;

          this.tableData = this.getDescList(this.specsMap);

          this.descList = this.getDescList(this.specsMap) ;

        return false
      }

      this.picVisible = false;

    //   let id = this.uuid2();
    //   this.list[indexs].specsValue.push({ name: value, id: id });
    //   let specss = []
    //   this.list.forEach((val)=> {
    //     console.log(val,'sd')
    //     specss.push(this.specsMap[val.specsName]);
    //   })
    //   console.log(specss,specss,'specss')
    // return

      if (type == 0) {
        let id = this.uuid2();

        this.list[indexs].specsValue.push({ name: value, id: id });
      }

      let specs = this.specsMap[this.list[indexs].specsName];


      if (type == 0) {
        if (!(specs != undefined && specs.length > 0)) {
          specs = new Array();
        }
        specs.push(value);
      } else if (type == 1) {
        specs = specs.filter((num, index) => {
          return num !== value;
        });

        // this.list[indexs].specsValue.splice(idx, 1); //删除 tag
        specs.splice(idx, 1); //删除 tag
      }

      if (type == 2) {
        delete this.specsMap[this.list[indexs].specsName];
      } else {
        this.specsMap[this.list[indexs].specsName] = specs;
      }
      this.columns = [];

      for (const key in this.specsMap) {

        this.columns.unshift({
          title: key,
          dataIndex: key,
          // width: 150
        });
      }
      // if()
        this.columns.push(
          // {
          //   title: "规格图片",
          //   dataIndex: "createTime",
          //   width: 100
          // },
          {
            title: "市场价(元)",
            dataIndex: "marketPrice",
            scopedSlots: { customRender: "marketPrice" },
            // width: 100
          },
          {
            title: "回收价(元)",
            dataIndex: "evaluatePrice",
            scopedSlots: { customRender: "evaluatePrice" },
            // width: 100
          },
          {
            title: "启用状态",
            // width: 100,
            scopedSlots: { customRender: "state" }
          },
          {
            title: "操作",
            scopedSlots: { customRender: "operation" }
          }
        );


          this.tableData =this.getDescList(this.specsMap) ;
          this.descList = this.getDescList(this.specsMap) ;

    },
    handleChange(value, key, column) {
      // this.$nextTick(() => {
      this.tableData.map((val, index) => {
        if (val == key) {
          val.evaluatePrice = value;
          val.state = val.state ? val.state : 1;
        }
      });
      // })
      this.tableData = this.tableData;
    },

    handle(value, key, column) {
      // 表格input绑定值

      //  this.$nextTick(() => {
      this.tableData.map((val, index) => {

        if (val == key) {
          val.marketPrice = value;
          val.state = val.state ? val.state : 1;
          val.ids = val.ids ? val.ids : [];
        }
      });
      //  })
    },
    handleTableChange() {},
    setAudioStatus(text, e) {

      this.tableData.forEach((val, index) => {
        if (val == e) {
          val.state = text == true ? 0 : 1;
        }
      });

    },
    remove(e, index) {

      this.submit(this.desc, 2, "", index,'删除');
      this.list.splice(index, 1); //删除 tag
    },
    // 列表
    getTableData() {
      const param = {};
      param.queryParams = {};
      param.page = this.pagination.pageNo;
      param.pageSize = this.pagination.pageSize;

      this.loading = true;

      getList(param)
        .then(res => {

          this.applicableEnds = res.result.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset(){
      this.tableData = [],
      this.descList = [],
      this.specsMap= {},
      this.NewspecsMap=[],
      this.categoryId = "", //分类id
    this.columns = [
        // {
        //   title: "规格图片",
        //   dataIndex: "createTime"
        // },
        {
          title: "市场价(元)",
          dataIndex: "marketPrice",
          scopedSlots: { customRender: "marketPrice" },
          // width: 100
        },
        {
          title: "回收价(元)",
          dataIndex: "evaluatePrice",
          scopedSlots: { customRender: "evaluatePrice" },
          // width: 100
        },
        {
          title: "启用状态",
          // width: 100,
          scopedSlots: { customRender: "state" }
        },{
          title:'操作',
          scopedSlots: { customRender: "operation" }

        }
      ],
      this.list= [{ name: "规格项", specsName: "", specsValue: [] }]
    },
    goback(){
          this.$router.push({
            path: "/appRegulated/appRegulated"
          });
    },
    // 保存
    save() {


      let evaluateSpecifications = [];

      this.list.forEach((val, id) => {
        val.specsValue.forEach((e, index) => {
          evaluateSpecifications.push({
            id: e.id,
            specsName: val.specsName,
            categoryId: this.categoryId,
            specsValue: e.name
          });
        });
        if(this.descList.length > 0){
             let num = 0;
          if(this.tableData.length > this.descList.length){
              num = this.newData.length
          }


          // (var i of this.descList)   new Map( this.descList.map( ( item, index ) => [ i, item ] ) )
          for (var i of this.descList) {

            num = num + 1;
            for (var k in i) {
              val.specsValue.forEach((e, index) => {

                // console.log(e,i[k],i,k,this.tableData[0].ids,this.tableData[2].ids,'进来了undefined ')
                if (val.specsName == k) {
                  if(this.tableData[num - 1].ids == undefined ){

                  }
                  if (e.name == i[k]  ) {
                    // console.log(this.tableData[num - 1].ids,e.id,'原长城id')

                          this.tableData[num - 1].ids.push(e.id);


                  }
                }
              });
            }
          }
        }


      });


      let data = [];


      this.tableData.forEach(val => {

        if(this.descList.length > 0){
          data.push({
            id: val.id ? val.id : "",
            specsTemplate: val.specsTemplate ? val.specsTemplate : val.ids.join(","),
            categoryId: this.categoryId,
            evaluatePrice: Number(val.evaluatePrice) ,
            marketPrice: Number(val.marketPrice) ,
            state: val.state,
            evaluateType:0
          });
        }


        // specsTemplate = "{"
        // for (const key in val) {
        //   specsTemplate +=  (key+ ":'" + val[key] + "',")
        // }
        // specsTemplate = specsTemplate.substring(0, specsTemplate.length -1);
        // specsTemplate += "}";

        val.categoryId = this.categoryId;
      });


      const params = {};
      params.evaluateSpecifications = evaluateSpecifications,
        params.evaluateSpecificationsDetails = this.descList.length > 0 ? data : this.tableData,
        params.categoryId = this.categoryId,
        save(params).then(res => {
          this.$router.push({
            path: "/appRegulated/appRegulated"
          });
        });
    },
    // 删除表格行
    removeMember(e){

            const newData = this.tableData.filter(item => item.id !== e.id)
            this.tableData = newData
    },
  }
};
</script>

<style></style>
